import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosProxy } from '../../api/axiosProxy/axiosProxy';
import { rejectFailedRequestOrEmptyData } from '../../lib/request/rejectFailedRequest/rejectFailedRequest';

export const usePostChildOrganization = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      name,
      organizationId,
      addAllCurrentAdminsToSubOrg,
    }: {
      name: string;
      organizationId: string;
      addAllCurrentAdminsToSubOrg: boolean;
    }) => {
      const response = await AxiosProxy.post({
        url: `sub-organizations`,
        withCredentials: true,
        body: {
          name,
          addAllCurrentAdminsToSubOrg,
        },
      });

      await rejectFailedRequestOrEmptyData(response);

      return;
    },
    onSuccess: () => {
      // Invalidate user.
      queryClient.invalidateQueries(['childOrganizations']);
      queryClient.invalidateQueries(['currentOrganization']);
      queryClient.invalidateQueries(['user']);
    },
  });
};
